import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const LinkIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    {...props}
  >
    <Path
      d="M4.75 8H12.75M11.4167 12H13.75C15.4069 12 16.75 10.6569 16.75 9V7C16.75 5.34315 15.4069 4 13.75 4H11.4167M6.08333 4H3.75C2.09315 4 0.75 5.34315 0.75 7V9C0.75 10.6569 2.09315 12 3.75 12H6.08333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

LinkIcon.displayName = 'LinkIcon';
